import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import sellerOnboardingReducer from './slices/sellerOnboardingSlice';
import cartReducer from './slices/cartSlice';
import wishlistReducer from './slices/wishlistSlice';
import followReducer from './slices/followSlice';

export const store = configureStore({
    reducer: {
      auth: authReducer,
      sellerOnboarding: sellerOnboardingReducer,
      cart: cartReducer,
      wishlist: wishlistReducer,
      follow: followReducer,
    },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['sellerOnboarding/setOTPData'],
      },
    }),
});

export default store;